var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.page,{tag:"component",on:{"changePage":_vm.changePage}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa01700a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/component/app.html
// module id = 432
// module chunks = 0